import React from "react";
import { EnumUserAcces, ShiftPlanEmployee } from "../Managers/dataStructures";
import { ActivityIndicator } from "../Managers/utilityComponents";
import { getLanguage } from "../Managers/dataProvider";

interface SPShiftPlanProps {
  array_shiftEmployees: ShiftPlanEmployee[];
  removeEmployee: (item: ShiftPlanEmployee) => void;
  isDisabled: boolean;
  makeTempTeamlead: (item: ShiftPlanEmployee) => void;
  isActivityIndicator: boolean;
  isGeneratingPDF: boolean;
  tl_id: string | undefined;
}

export default function SpShiftPlanPanel(props: SPShiftPlanProps) {
  const isTeamLeadPresent: boolean = checkForTLPresence();
  const isTempTLPresent: boolean = checkForTempTLPresence();
  const isEnglish = getLanguage();

  function removeEmployee(item: ShiftPlanEmployee) {
    props.removeEmployee(item);
  }

  function makeTeamLead(item: ShiftPlanEmployee) {
    props.makeTempTeamlead(item);
  }

  function checkForTLPresence() {
    const tlIndex: number = props.array_shiftEmployees.findIndex(
      (x) => x.user.role.type === EnumUserAcces.TEAM_LEAD
    );
    if (tlIndex === -1) {
      return false;
    }
    return true;
  }
  function checkForTempTLPresence() {
    const tlIndex: number = props.array_shiftEmployees.findIndex(
      (x) => x.user.tempRole?.type === EnumUserAcces.TEMP_TEAM_LEAD
    );
    if (tlIndex === -1) {
      //return false;
      if (props.tl_id !== undefined) {
        const tl2Index: number = props.array_shiftEmployees.findIndex(
          (x) => x.user.user_id === props.tl_id
        );
        if (tl2Index !== -1) {
          return true;
        }
      }
      return false;
    }
    return true;
  }

  return (
    <div>
      <div className="mt-5 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              {props.isActivityIndicator === true ? (
                <div className="py-5 items-center flex flex-col">
                  {ActivityIndicator(1)}
                </div>
              ) : (
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                      >
                        {isEnglish ? "Name" : "Name"}
                      </th>

                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {isEnglish ? "Start Time" : "Arbeitsbeginn"}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {isEnglish ? "End Time" : "Arbeitsende"}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {isEnglish ? "Role" : "Aufgabe"}
                      </th>
                      <th
                        scope="col"
                        className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                      >
                        <span className="sr-only">
                          {isEnglish ? "Edit" : "Edit"}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  {props.array_shiftEmployees.map((x) =>
                    CellShiftPlan(
                      x,
                      removeEmployee,
                      props.isDisabled,
                      makeTeamLead,
                      isTeamLeadPresent,
                      isTempTLPresent,
                      props.tl_id,
                      props.isGeneratingPDF
                    )
                  )}
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function CellShiftPlan(
  item: ShiftPlanEmployee,
  removeEmployee: (item: ShiftPlanEmployee) => void,
  isDisabled: boolean,
  makeTeamLead: (item: ShiftPlanEmployee) => void,
  isTeamLeadAssigned: boolean,
  isTempLeadPresent: boolean,
  tl_id: string | undefined,
  isGeneratingPDF: boolean
) {
  const isEnglish = getLanguage();
  const isUserTempTL: boolean = item.user.tempRole === undefined ? false : true;
  const isTwinButton: boolean = isTeamLeadAssigned
    ? false
    : isTempLeadPresent && isUserTempTL === false
    ? false
    : true;
  function removeEmployee_() {
    removeEmployee(item);
  }
  function makeTeamLead_() {
    makeTeamLead(item);
  }

  let isTl: boolean = false;
  if (tl_id !== undefined) {
    isTl = item.user.user_id === tl_id;
  }
  const tl: string =
    item.user.role.type === EnumUserAcces.TEAM_LEAD ||
    item.user.role.type === EnumUserAcces.TEMP_TEAM_LEAD ||
    item.user.tempRole?.type === EnumUserAcces.TEMP_TEAM_LEAD ||
    isTl
      ? "text-green-700 ring-green-600/20 bg-green-50"
      : "";

  return (
    <tbody
      className="divide-y divide-gray-200 bg-white"
      key={item.user.user_id}
    >
      <tr>
        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 flex-auto">
          <p className="text-sm font-semibold leading-6 text-gray-900">
            {item.user.first_name + " " + item.user.last_name}
          </p>
          <p className="mt-1  text-xs leading-5 text-gray-500">
            {item.user.employee_id}
          </p>
        </td>
        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
          {item.employee_start_at !== undefined
            ? item.employee_start_at
            : "--:--"}
        </td>
        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
          {item.employee_end_at !== undefined ? item.employee_end_at : "--:--"}
        </td>
        <td className={"whitespace-nowrap px-3 py-4 text-sm text-gray-500 "}>
          <span
            className={
              isGeneratingPDF === true
                ? "inline-flex text-xs font-medium px-2 py-2"
                : "inline-flex items-center rounded-md px-2 py-2 text-xs font-medium ring-1 ring-inset " +
                  tl
            }
          >
            {isUserTempTL
              ? item.user.tempRole?.display_name
              : item.user.role.type === EnumUserAcces.TEAM_LEAD
              ? item.user.role.display_name
              : isTl
              ? isEnglish
                ? "Team Lead"
                : "Teamleiter"
              : item.user.role.display_name}
          </span>
        </td>

        {isDisabled === true ? null : (
          <td
            className={
              "relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6 " +
              (isTwinButton === false ? "" : "flex flex-col")
            }
          >
            <a
              href={"#" + item.user.user_id}
              className="text-indigo-600 hover:text-indigo-900"
              onClick={removeEmployee_}
            >
              {isEnglish ? "Remove" : "Entfernen"}
              <span className="sr-only">, {item.user.email_id}</span>
            </a>
            {isTwinButton ? (
              <a
                href={"#mtl_" + item.user.user_id}
                className="text-indigo-600 hover:text-indigo-900"
                onClick={makeTeamLead_}
              >
                {isTempLeadPresent
                  ? isEnglish
                    ? "Remove Team-lead"
                    : "Teamleitung stornieren"
                  : isEnglish
                  ? "Make Team-lead"
                  : "Zum Teamleiter ernennen"}
                <span className="sr-only">, {item.user.email_id}</span>
              </a>
            ) : null}
          </td>
        )}
      </tr>
    </tbody>
  );
}
